import { formatGeneral } from 'cleave-zen';

// FIXME: remove this and use another method to format
//        cnpj
export const formatCNPJ = (value: unknown): string => {
  if (value === undefined || typeof value !== 'string') {
    return '';
  }

  return formatGeneral(value, {
    blocks: [2, 3, 3, 4, 2],
    delimiters: ['.', '.', '/', '-', ''],
    numericOnly: true,
  });
};
